// axios lower-cases response header names
export const ZAMMAD_NOTE_HEADER = "x-zammad-note";
export const NOT_ADDED = "not-added";
export const AMBER_TIMEOUT_MS = 10000;

const NOTE_MISSING_TEXT =
  "The Zammad ticket note hasn't been added yet, please check the ticket and add it if it's missing.";

/**
 * True when the API accepted the request but did not write the Zammad note.
 * @param {{ headers?: Object }|null|undefined} response axios response
 * @returns {boolean}
 */
export function zammadNoteNotAdded(response) {
  return !!(
    response &&
    response.headers &&
    response.headers[ZAMMAD_NOTE_HEADER] === NOT_ADDED
  );
}

/**
 * Toast payload shown after a request was submitted to NBN.
 * @param {string} action e.g. "Withdrawal", "Disconnection"
 * @param {{ headers?: Object }|null|undefined} response axios response
 * @returns {{ text: string, color: string, timeout?: number }}
 */
export function submittedToast(action, response) {
  const text = `${action} submitted to NBN.`;

  if (zammadNoteNotAdded(response)) {
    return {
      text: `${text} ${NOTE_MISSING_TEXT}`,
      color: "warning",
      timeout: AMBER_TIMEOUT_MS
    };
  }

  return { text, color: "success" };
}
